import PostCommentPanel from './PostCommentPanel'
export default PostCommentPanel



// WEBPACK FOOTER //
// ./src/components/PostCommentPanel/index.js